import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { forwardRef, memo, useMemo, useRef } from 'react';
import { useCookieBannerHeight } from "../../../cookie-banner";
import SeeMoreLink from "../see-more-link/see-more-link";
import { MenuLayout } from "../../types";
import { SubMenuContainer, SubMenuContent } from "./sub-menu.styles";
import SubMenuWithColumns from "./sub-menu-with-columns";
import { SubMenuWithGallery } from "./sub-menu-with-gallery";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SubMenu = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var items = _ref.items,
    isActive = _ref.isActive,
    layout = _ref.layout,
    seeMoreLink = _ref.seeMoreLink,
    onTransitionEnd = _ref.onTransitionEnd,
    onItemClick = _ref.onItemClick,
    palette = _ref.palette;
  var _contentRef$current$o, _contentRef$current;
  var contentRef = useRef(null);
  var cookieBannerHeight = useCookieBannerHeight() || 0;
  var SubMenuWithLayout = useMemo(function () {
    switch (layout) {
      case MenuLayout.Gallery:
        return SubMenuWithGallery;
      case MenuLayout.Columns:
      default:
        return SubMenuWithColumns;
    }
  }, [layout]);
  var maxHeight = (_contentRef$current$o = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.offsetHeight) !== null && _contentRef$current$o !== void 0 ? _contentRef$current$o : 0;
  return /*#__PURE__*/_jsx(SubMenuContainer, {
    ref: ref,
    isActive: isActive,
    onTransitionEnd: onTransitionEnd,
    cookieBannerHeight: cookieBannerHeight,
    maxHeight: maxHeight,
    children: /*#__PURE__*/_jsxs(SubMenuContent, {
      ref: contentRef,
      children: [/*#__PURE__*/_jsx(SubMenuWithLayout, {
        items: items,
        onItemClick: onItemClick,
        palette: palette
      }), seeMoreLink && /*#__PURE__*/_jsx(SeeMoreLink, _objectSpread({
        onClick: onItemClick
      }, seeMoreLink))]
    })
  });
});
export default /*#__PURE__*/memo(SubMenu);